import React from "react";
import RubricTableWithReordering from "./RubricTableWithReordering";

const RubricTableWithReorderingWrapper = props => {
  // TODO: revisit V2 component later
  // return !getIsScoreBasedRubricEnabled() ? (
  //   <RubricTableWithReorderingV2 {...props} />
  // ) : (
  //   <RubricTableWithReordering {...props} />
  // );

  return <RubricTableWithReordering {...props} />;
};

export default RubricTableWithReorderingWrapper;
